export function extractErrorMessage(statusMessage) {
    if (!statusMessage) return '';

    // Handle XML message
    const xmlMatch = statusMessage.match(/<message>(.*?)<\/message>/);
    if (xmlMatch) return xmlMatch[1];

    // Extract HTTP status codes (e.g., "504 Gateway Time-out", "400 Bad Request")
    const httpStatusMatch = statusMessage.match(/(\d{3}\s+[A-Za-z][\w\s-]+?)(?::|"|\s*<|$)/);
    if (httpStatusMatch) {
        return httpStatusMatch[1].trim();
    }

    // Handle semicolon-separated errors
    const semicolonIndex = statusMessage.indexOf(';');
    if (semicolonIndex !== -1) {
        return statusMessage.substring(0, semicolonIndex).trim();
    }

    // Remove Java exception class names first (e.g., "java.lang.RuntimeException:")
    let cleaned = statusMessage.replace(/^[\w.]+Exception\$?\w*:\s*/i, '');
    cleaned = cleaned.replace(/org\.springframework[\w.]+:\s*/g, '');

    // Extract the part before ".message" or " cause:" (whichever comes first)
    const messageIndex = cleaned.indexOf('.message');
    const causeIndex = cleaned.indexOf(' cause:');

    if (messageIndex !== -1 && (causeIndex === -1 || messageIndex < causeIndex)) {
        cleaned = cleaned.substring(0, messageIndex).trim();
    } else if (causeIndex !== -1) {
        cleaned = cleaned.substring(0, causeIndex).trim();
    }

    // Remove HTML content and EOL markers
    cleaned = cleaned.replace(/<[^>]*>/g, '').replace(/<EOL>/gi, ' ');
    cleaned = cleaned.replace(/\s+/g, ' ').trim();

    // Remove surrounding quotes
    cleaned = cleaned.replace(/^["']|["']$/g, '').trim();

    // If we cleaned it too much, return original (fallback for simple messages)
    if (!cleaned) return statusMessage;

    return cleaned;
}